module.exports = __webpack_public_path__ + "img/accreditation-winner.bf784bb6.png";